export default "__VITE_ASSET__DjxS9z_v__"